import request, {requestJson} from '../main';
const service = ""
class InspectionOrderApi {
    private url: string = service + "/inspection-order";
    //计量器具检定申请列表
    public list(args: any){
        return request({
            url: this.url + '/list',
            method: 'get',
            params: args
        })
    }
    //提交器具的申请
    public submitInstrumentApp(args: any){
        return request({
            url: this.url + '/submit-instrument-app',
            method: 'post',
            data: args
        })
    }
    //器具检定详情
    public listOrderDetails(args: any){
        return request({
            url: this.url + '/list-order-details',
            method: 'get',
            params: args
        })
    }
    //器具检定详情2
    public listDetails(args: any){
        return request({
            url: this.url + '/list-details',
            method: 'get',
            params: args
        })
    }
    //器具检定详情3 在编辑检定器具订单时使用
    public getOrderDetail(args: any){
        return request({
            url: this.url + '/get-order-detail',
            method: 'get',
            params: args
        })
    }
    //器具的申请
    public listInspectionOrderApply(args: any){
        return request({
            url: this.url + '/list-inspection-order-apply',
            method: 'get',
            params: args
        })
    }
    //设置技术机构的检定人
    public settingInspectionOrderApply(args: any){
        return request({
            url: this.url + '/setting-inspection-order-apply',
            method: 'post',
            data: args
        })
    }
    //添加器具检定信息
    public updateInspectionOrderInstruments(args: any){
        return request({
            url: this.url + '/update-inspection-order-instruments',
            method: 'post',
            data: args
        })
    }
    //编辑器具检定信息
    public updateInspectionOrderInstrumentsById(args: any){
        return requestJson({
            url: this.url + '/update-inspection-order-instruments-by-id',
            method: 'post',
            data: args
        })
    }
    //删除器具检定信息
    public deleteInspectionOrderInstruments(args: any){
        return request({
            url: this.url + '/delete-inspection-order-instruments',
            method: 'post',
            data: args
        })
    }
    //编辑器具检定信息
    public getInspectionOrderInstruments(args: any){
        return request({
            url: this.url + '/get-inspection-order-instruments',
            method: 'GET',
            params: args
        })
    }

    //根据器具ID查询申请记录
    public listOrderByInstrumentId(args: any){
        return request({
            url: this.url + '/list-order-by-instrument-id',
            method: 'GET',
            params: args
        })
    }
    //删除检定订单
    public deleteOrder(args: any){
        return request({
            url: this.url + '/delete-order',
            method: 'post',
            data: args
        })
    }
    //退回
    public returnInspectionOrderApply(args: any){
        return request({
            url: this.url + '/return-inspection-order-apply',
            method: 'GET',
            params: args
        })
    }
    //检测单位直接查器具
    public listInspectionOrderInstruments(args: any){
        return request({
            url: this.url + '/list-inspection-order-instruments',
            method: 'GET',
            params: args
        })
    }
    //检测单位直接查器具的id
    public listInspectionOrderInstrumentIds(args: any){
        return request({
            url: this.url + '/list-inspection-order-instrumentIds',
            method: 'GET',
            params: args
        })
    }
    //提交检定时的分配结果预览
    public assignTestOrg(args: any){
        return request({
            url: this.url + '/assign-test-org',
            method: 'POST',
            data: args
        })
    }

    //器具检定完成后上报接口
    public instrumentReport(args: any){
        return request({
            url: this.url + '/instrument-report',
            method: 'GET',
            params: args
        })
    }

    //器具受理不受理
    public acceptanceOrNot(args: any){
        return request({
            url: this.url + '/acceptance-or-not',
            method: 'post',
            data: args
        })
    }

    //根据检测机构ID进行查询 需要检定的器具
    public listInspectionOrderByTechnicalDepartId(args: any){
        return request({
            url: this.url + '/list-inspection-order-by-technicalDepartId',
            method: 'get',
            params: args
        })
    }


    public getInspectionOrderApplyDetail(args: any){
        return request({
            url: this.url + '/get-inspection-order-apply-detail',
            method: 'get',
            params: args
        })
    }

    public updateOrderApplyProveStatus(args: any){
        return request({
            url: this.url + '/update-order-apply-prove-status',
            method: 'get',
            params: args
        })
    }

    //导出检定器具
    public exportInstruments(args: any){
        return request({
            url: this.url + '/export-instruments',
            method: 'post',
            data: args
        })
    }
    //导入检定器具
    public importInstrumentReport(args: any){
        return request({
            url: this.url + '/import-instrument-report',
            method: 'post',
            data: args
        })
    }
    //获取无匹配器具流水号
    public getSerialNumber(args: any){
        return request({
            url: this.url + '/get-serial-number',
            method: 'get',
            params: args
        })
    }

    public haveProgressOrderInstr(instrId: number){
        return request({
            url: this.url + '/have-progress-order-instr',
            method: 'get',
            params: {
                instrId: instrId
            }
        })
    }

    public saveData(orderInstrId: any, instrId: any, data: string){
        return request({
            url: this.url + '/save-data',
            method: 'post',
            data: {
                orderInstrId: orderInstrId,
                instrId: instrId,
                data: data
            }
        })
    }

    public hasAddCheckRecord(instrId: number){
        return request({
            url: this.url + '/has-add-check-record',
            method: 'get',
            params: {
                instrId: instrId
            }
        });
    }

}
const inspectionOrderApi = new InspectionOrderApi();
export {inspectionOrderApi}
